export interface SubscriptionsSummary {
  subscription: {
    plan: 'trial' | 'community' | 'starter' | 'essential' | 'professional' | 'enterprise';
    status: 'trialing' | 'active' | 'past_due' | 'grace' | 'suspended' | 'cancelled' | 'expired';
    billingInterval: 'monthly' | 'annual' | null;
    trialEndsAt: string | null;
    currentPeriodStart: string | null;
    currentPeriodEnd: string | null;
    includedSeats: number;
    purchasedSeats: number;
    totalSeats: number;
    pendingProrationMinor: number;
    seatsInUse: number;
    seatsAvailable: number;
    cancelAtPeriodEnd?: boolean;
    cancelledAt?: string | null;
    pendingPlan?: 'essential' | 'professional' | null;
    pendingBillingInterval?: 'monthly' | 'annual' | null;
  };
  community: {
    memberCount: number;
    limit: number;
    qualifies: boolean;
    requiresUpgrade: boolean;
    requiresPaidUpgrade?: boolean;
  };
  starter: {
    memberCount: number;
    limit: number;
    qualifies: boolean;
    requiresUpgrade: boolean;
  };
  storage?: {
    usedBytes: number;
    quotaBytes: number | null;
  };
  checkout?: {
    paymentsConfigured: boolean;
    testCheckoutAllowed: boolean;
    plans: Array<{
      plan: 'essential' | 'professional';
      includedSeats: number;
      currency: string;
      monthlyAmountMinor: number;
      annualAmountMinor: number;
    }>;
  };
  entitlements: Record<string, boolean | string>;
  access?: {
    consoleWritable: boolean;
    refusalCode: string | null;
  };
  management?: {
    canAdjustPlan: boolean;
    canCancel: boolean;
    canResume: boolean;
    canClearScheduledChange: boolean;
    canRenewCurrentPlan: boolean;
    canAddPurchasedSeat: boolean;
    pendingPlan: 'essential' | 'professional' | null;
    pendingBillingInterval: 'monthly' | 'annual' | null;
  };
}

export interface AssignedCoupon {
  id: string;
  code: string;
  discountType: 'percent' | 'amount' | 'free_months';
  discountValue: number;
  durationType: 'once' | 'repeating' | 'forever';
  durationMonths: number | null;
  status: 'available' | 'applied';
}

export interface AppliedCoupon {
  code: string;
  subtotalMinor: number;
  discountMinor: number;
  totalMinor: number;
  bonusMonths: number;
  durationType?: 'once' | 'repeating' | 'forever';
  durationMonths?: number | null;
}

export interface ReferralSummary {
  referralCode: string;
  referralCount: number;
  rewardedCount: number;
}

export interface CheckoutSession {
  id: string;
  status: string;
  checkoutUrl: string | null;
  testMode: boolean;
}

export type CheckoutPlan = NonNullable<SubscriptionsSummary['checkout']>['plans'][number];

export type PaidPlan = 'essential' | 'professional';

export const PAID_PLAN_RANK: Record<PaidPlan, number> = {
  essential: 1,
  professional: 2,
};
